// Global variables for description management (shared across all sections)
var originalEnglishDescription = "";
var originalJapaneseDescription = "";
var descriptionsStored = false;

// Which base image column reflects the CURRENT variant selection: "product" or
// "variant". updateVariantDetails (in initVariantSelect) is the single owner and
// updates this every time it sets the columns; the instruction toggle reads it
// instead of sniffing `style.display === "flex"`. The display sniff was the
// fragile bit — on a cold first interaction the inline display can still be ""
// (CSS-driven, not yet normalized), so the toggle guessed "product" and, on a
// variant whose images live in #variant-images, restored the wrong / empty
// column next to the still-shown one. That's the "select a variant then press
// instruction manual, once, on first load" desync. Sourcing the base from the
// selection truth makes it deterministic.
var pvActiveBaseColumn = "product";

console.log("expand loaded");
console.log("i.m loaded");

// Single entry point. Each section lives in its own init function so their
// local names (handleResize, instructionButton, jpText, enText,
// instructionImages, …) stay scoped and don't collide.
var __productVariantsInitialized = false;
function initProductVariants() {
  if (__productVariantsInitialized) return;
  __productVariantsInitialized = true;
  initExpandToggle();
  initVariantSelect();
  initInstructionManual();
}

// Run on DOMContentLoaded — deliberately NOT synchronously. script-functions.js
// initializeImageLoading() also runs on DOMContentLoaded, and because it loads in
// <head> its handler is registered (and runs) first: it sets every
// .product-page-image to display:none and reassigns src to re-trigger load.
// Variant init MUST run after that — otherwise the image-loader wipes the
// variant images this just revealed, and cached images whose load doesn't
// re-fire stay hidden (the intermittent "variant shows no images" bug).
//
// The PDP modal (script-index-product.js → pmRunScripts) rewrites the literal
// "DOMContentLoaded" below to its own ready event and dispatches it after
// injecting the product scripts, so that path keeps working too. The guard +
// `var` flag keep a re-injected copy from double-initialising.
document.addEventListener("DOMContentLoaded", initProductVariants);

// EXPAND.JS
function initExpandToggle() {
  const expandButton = document.getElementById("expand");
  let isExpanded = false;

  // Cache the elements toggled on every expand/collapse instead of re-querying
  // them inside applyExpandedStyles / applyCollapsedStyles on each call.
  const descContainer = document.querySelector(".product-description-container");
  const dimWeightMfg = document.querySelector(
    ".description-dimensions-weight-manufacturing"
  );
  const titleContainer = document.querySelector(".product-title-container");
  const skuExpand = document.querySelector(".sku-expand");
  const expandPlus = document.querySelector(".expand-plus");
  const expandMinus = document.querySelector(".expand-minus");

  const applyExpandedStyles = () => {
    descContainer.style.gap = "15px";
    dimWeightMfg.style.display = "flex";
    titleContainer.style.display = "block";
    skuExpand.style["font-size"] = "11.5px";
    expandPlus.style.display = "none";
    expandMinus.style.display = "block";
  };

  const applyCollapsedStyles = () => {
    dimWeightMfg.style.display = "none";
    titleContainer.style.display = "none";
    skuExpand.style["font-size"] = "13px";
    expandPlus.style.display = "block";
    expandMinus.style.display = "none";
  };

  // Toggle functionality for below 700px
  expandButton.addEventListener("click", function () {
    if (!isExpanded) {
      applyExpandedStyles();
    } else {
      applyCollapsedStyles();
    }
    isExpanded = !isExpanded;

    // Handle dimming when expanding/collapsing description on mobile
    setTimeout(() => {
      if (window.innerWidth <= 430) {
        const descEnJp = document.querySelector(".product-description-en-jp");
        const instructionImages = document.getElementById("instruction-images");

        if (descContainer && descEnJp && instructionImages) {
          // Check if description height is >= 35dvh and instruction manual is open
          const descHeight = descEnJp.offsetHeight;
          const viewportHeight = window.innerHeight;
          const thirtyFiveDvh = (viewportHeight * 35) / 100;

          if (
            descHeight >= thirtyFiveDvh &&
            instructionImages.style.display === "flex"
          ) {
            // Apply dimming when expanding
            descContainer.classList.add("dimmed");
            document.body.style.overflow = "hidden";
          } else {
            // Remove dimming when collapsing
            descContainer.classList.remove("dimmed");
            document.body.style.overflow = "auto";
          }
        }
      }
    }, 50);
  });

  // Detect window resizing and apply changes
  const mediaQuery = window.matchMedia("(min-width: 701px)");

  const handleResize = (e) => {
    if (e.matches) {
      // Apply expanded styles when browser is above 700px
      applyExpandedStyles();
      isExpanded = true;
    } else {
      // Automatically collapse styles when below 700px
      applyCollapsedStyles();
      isExpanded = false; // Reset expanded state
    }
  };

  mediaQuery.addListener(handleResize); // Listen for screen size changes
  handleResize(mediaQuery); // Initial check when the page loads
}

// SELECT.JS
function initVariantSelect() {
  const variantSelect = document.querySelector(".variant-dropdown-button");
  const selectedVariantDisplay = document.querySelector(".selected-variant"); // lol its this
  const priceDisplay = document.querySelector(".price");
  const addToCartForm = document.querySelector("#add-to-cart-form");
  const hiddenVariantIdInput = addToCartForm.querySelector('input[name="id"]');
  const addToCartText = document.querySelector(".add-to-cart-text");
  const soldOutText = document.querySelector(".sold-out-text");
  const addToCartButton = addToCartForm.querySelector("button");
  const productImagesContainer = document.getElementById("product-images");
  const variantImagesContainer = document.getElementById("variant-images");
  const weightDisplay = document.querySelector(".weight");
  const dimensionsDisplay = document.querySelector("#dimensions-display"); // Add dimensions display element
  const instructionImages = document.getElementById("instruction-images"); // Add reference to instruction images

  // Add references for button text elements. The instruction-manual button is
  // only rendered when the product has an instruction_manual_image metafield,
  // so it may be absent — guard the lookups. A null deref here would abort the
  // whole init, leaving the variant <select>'s change handler unattached (which
  // looks like "selecting a variant does nothing").
  const instructionButton = document.getElementById(
    "instruction-manual-button"
  );
  const jpText = instructionButton
    ? instructionButton.querySelector(".jp-font-close")
    : null;
  const enText = instructionButton
    ? instructionButton.querySelector(".product-page-button-content p:last-child")
    : null;

  // Function to update the variant details when the variant changes
  function updateVariantDetails() {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const selectedVariantId = selectedOption.value;
    const variant = variants[selectedVariantId]; // Get the selected variant data

    // Update the URL with the variant SKU. replaceState (not push) so flipping
    // variants doesn't spam the history stack — but MERGE into the existing state
    // instead of replacing it, and keep the current path + query (only swap the
    // hash). In the PDP-modal context THIS entry carries
    // { productModal:true, url } that script-index-product.js's popstate handler
    // reads to re-open the modal on a forward navigation. The old bare
    // replaceState({sku}) wiped that object: stepping forward back onto the PDP
    // entry then landed on the home grid instead of the product, and the #sku was
    // left stranded in the address bar after navigating away. On a standalone PDP
    // history.state is null, so the merge degrades to { sku } — identical to the
    // previous behaviour there.
    if (variant.sku) {
      const newUrl = window.location.pathname + window.location.search + "#" + variant.sku;
      history.replaceState(
        Object.assign({}, history.state, { sku: variant.sku }),
        "",
        newUrl
      );
    }

    // Update the selected variant display
    selectedVariantDisplay.textContent = variant.title;

    // Update the price display with the correct price
    priceDisplay.textContent = variant.price;

    // Update the hidden input for the selected variant ID in the "Add to Cart" form
    hiddenVariantIdInput.value = selectedVariantId;

    // Check if the variant is sold out - modified logic to handle empty and "false" values
    if (variant.soldOut && variant.soldOut !== "false") {
      // Disable the button and show sold-out text
      addToCartButton.disabled = true;
      addToCartText.style.display = "none"; // Hide "ADD TO CART"
      soldOutText.style.display = "block"; // Show "SOLD OUT"
    } else {
      // Enable the button and show "ADD TO CART"
      addToCartButton.disabled = false;
      addToCartText.style.display = "block"; // Show "ADD TO CART"
      soldOutText.style.display = "none"; // Hide "SOLD OUT"
    }

    // Capture whether the instruction view was open BEFORE we touch any
    // container, then restore the original descriptions if so. We must read this
    // first because the block below force-hides instruction-images, which would
    // otherwise erase the signal we use to know we should un-swap the text.
    const wasInstructionOpen = instructionImages.style.display === "flex";
    if (wasInstructionOpen && descriptionsStored) {
      const englishDescElement = document.querySelector(".description-text");
      const japaneseDescElement = document.querySelector(".description-text-jp");
      if (englishDescElement && originalEnglishDescription) {
        englishDescElement.innerHTML = originalEnglishDescription;
      }
      if (japaneseDescElement && originalJapaneseDescription) {
        japaneseDescElement.innerHTML = originalJapaneseDescription;
      }
    }

    // Decide which single column to show, then set ALL THREE containers
    // explicitly in one place. Changing a variant always exits the instruction
    // view, and exactly one base column ends up visible — making the "product +
    // variant (or base + instruction) showing at once / duplicated columns"
    // desync structurally impossible regardless of the prior state.
    let showVariantColumn = false;
    if (variant.images && variant.images.length > 0) {
      // Hide every per-variant image container, then reveal only this variant's.
      const allContainers = variantImagesContainer.querySelectorAll(
        ".img-and-loading-container"
      );
      allContainers.forEach((container) => (container.style.display = "none"));

      const variantContainers = variantImagesContainer.querySelectorAll(
        `.img-and-loading-container[data-variant-id="${selectedVariantId}"]`
      );

      if (variantContainers.length > 0) {
        showVariantColumn = true;
        variantContainers.forEach(
          (container) => (container.style.display = "block")
        );
      }
      // else: the variant claims images but none are in the DOM yet (still
      // rendering / data mismatch). Fall through to the product column so a base
      // view is ALWAYS visible — otherwise every column stays hidden and the
      // instruction toggle has nothing to return to (the "dead button" bug).
    }

    instructionImages.style.display = "none";
    productImagesContainer.style.display = showVariantColumn ? "none" : "flex";
    variantImagesContainer.style.display = showVariantColumn ? "flex" : "none";

    // Record the base column for this selection so the instruction toggle can
    // restore the right one without sniffing inline display (see declaration).
    pvActiveBaseColumn = showVariantColumn ? "variant" : "product";

    // Update the weight display based on the selected variant
    weightDisplay.textContent = variant.weight + " G";

    // Update the dimensions display (this is pre-filtered by Liquid)
    dimensionsDisplay.textContent = variant.dimensions; // Update the dimensions display

    // Change button text to "INSTRUCTION MANUAL" (English and Japanese)
    if (jpText) jpText.textContent = "取扱説明";
    if (enText) enText.textContent = "INSTRUCTION MANUAL";
  }

  // Check URL hash on page load and select variant if SKU is present
  const hash = window.location.hash.substring(1); // Get hash without the '#'
  if (hash) {
    // Find variant with matching SKU
    const variantId = Object.keys(variants).find(
      (id) => variants[id].sku === hash
    );
    if (variantId) {
      variantSelect.value = variantId;
    }
  }

  // Update variant details on page load
  updateVariantDetails();

  // Add event listener for when the variant changes
  variantSelect.addEventListener("change", updateVariantDetails);
}

// I.M.-TYPE2.JS
function initInstructionManual() {
  var instructionButton = document.getElementById("instruction-manual-button");
  // No instruction-manual button on this product → nothing to wire up.
  if (!instructionButton) return;
  // Never bind the click handler twice to the SAME button. In the PDP-modal path
  // the product scripts can be re-run, and a second click listener on one button
  // would fire the toggle an even number of times per click — opening then
  // instantly closing it, so the "switch" appears to do nothing and the button
  // looks dead. The button is recreated on every modal open, so this only guards
  // re-init against one element, never blocks a genuinely new button.
  if (instructionButton.dataset.imBound === "1") return;
  instructionButton.dataset.imBound = "1";
  var productImages = document.getElementById("product-images");
  var variantImages = document.getElementById("variant-images"); // This may not exist
  var instructionImages = document.getElementById("instruction-images");
  var imageContainer = document.querySelector(".product-page-wrapper");
  var mobileImageContainer = document.querySelector(".product-page-scrollable");
  // IMPORTANT: scope this to THIS product's wrapper. ".img-and-loading-container"
  // is also the class used by the index/collection product grids, so a
  // document-wide querySelectorAll would write inline width + pointer-events onto
  // every grid tile whenever the instruction manual is toggled — and because the
  // PDP runs as an injected modal over the index grid (and survives bfcache), that
  // stomped the grid sizing and left it stuck shrunk. Scoping keeps the toggle
  // confined to the product page's own images.
  var imgSize = imageContainer
    ? imageContainer.querySelectorAll(".img-and-loading-container")
    : [];
  var jpText = instructionButton.querySelector(".jp-font-close");
  var enText = instructionButton.querySelector(
    ".product-page-button-content p:last-child"
  );

  // Note: originalEnglishDescription, originalJapaneseDescription, and descriptionsStored
  // are now global variables declared at the top of the file

  // Tracks whether WE locked body scroll for the dim overlay, plus the value to
  // restore. Only the dim feature may touch body.style.overflow, and only while
  // it owns the lock — see handleDescriptionDimming.
  var dimLockApplied = false;
  var dimPrevOverflow = "";

  // Function to handle mobile description dimming
  function handleDescriptionDimming() {
    // Only apply on mobile
    if (window.innerWidth > 430) return;

    const descContainer = document.querySelector(
      ".product-description-container"
    );
    const descEnJp = document.querySelector(".product-description-en-jp");

    if (!descContainer || !descEnJp) return;

    // Check if description height is >= 35dvh
    const descHeight = descEnJp.offsetHeight;
    const viewportHeight = window.innerHeight;
    const thirtyFiveDvh = (viewportHeight * 35) / 100;

    const shouldDim =
      descHeight >= thirtyFiveDvh &&
      instructionImages.style.display === "flex";

    if (shouldDim) {
      // Dim the description background and prevent body scroll.
      descContainer.classList.add("dimmed");
      if (!dimLockApplied) {
        // Capture the prior value so we restore EXACTLY what was there — in the
        // PDP modal that's "hidden" (the modal's own scroll-lock), on a hard PDP
        // it's "" (default scrollable). Restoring blindly to "auto" would unlock
        // the modal.
        dimPrevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        dimLockApplied = true;
      }
    } else {
      descContainer.classList.remove("dimmed");
      // CRITICAL: only restore overflow if WE locked it. Writing body.overflow
      // here unconditionally fired on every resize — and mobile fires resize on
      // each URL-bar show/hide during a fast scroll, so it stomped overflow
      // mid-scroll and halted momentum scrolling (and fought the modal lock).
      if (dimLockApplied) {
        document.body.style.overflow = dimPrevOverflow;
        dimLockApplied = false;
      }
    }
  }

  function handleResize() {
    imgSize.forEach((element) => {
      if (instructionImages.style.display === "flex") {
        if (window.innerWidth <= 700) {
          element.style.width = "75%";
        } else {
          element.style.width = "50%";
        }
      } else if (productImages.style.display === "flex") {
        if (window.innerWidth <= 700) {
          element.style.width = "80%";
        } else {
          element.style.width = "75%";
        }
      }
    });

    // Recalculate dimming on resize
    handleDescriptionDimming();
  }

  window.addEventListener("resize", handleResize);

  // No click gating. The toggle is deterministic (it hides BOTH base containers
  // and restores exactly one) and the handler is bound once per button, so every
  // click switches cleanly — even mid-load, where the instruction images just
  // show their loader until they decode. The earlier "dead button" / bounce came
  // from non-deterministic show/hide + double-binding, not from missing gates,
  // so switching is now free to happen whenever.
  instructionButton.addEventListener("click", function () {
    // The base column to return to is owned by updateVariantDetails
    // (pvActiveBaseColumn), which is set from the actual variant selection on
    // load and on every change. We no longer re-derive it from inline display
    // here — that string-sniff was "" before normalization on a cold first
    // click, which is what produced the variant-then-instruction desync.

    // SELF-HEAL: before toggling, force a single known column state. Repeatedly
    // opening products in the PDP modal could leave BOTH base columns shown at
    // once (visible side-by-side on desktop, where the left column is a flex
    // row; stacked on mobile). If that desync is present and we DON'T normalize,
    // a click can swap one half and leave the other — the "variant next to the
    // instruction images" bug. Collapsing to exactly one truthful state here
    // makes the subsequent open/close deterministic no matter how we got here.
    var instructionIsOpen = instructionImages.style.display === "flex";
    if (instructionIsOpen) {
      // In the instruction view, neither base must be showing.
      if (productImages) productImages.style.display = "none";
      if (variantImages) variantImages.style.display = "none";
    } else {
      // In a base view, exactly the selection's column must be showing.
      if (pvActiveBaseColumn === "variant" && variantImages) {
        variantImages.style.display = "flex";
        if (productImages) productImages.style.display = "none";
      } else {
        if (productImages) productImages.style.display = "flex";
        if (variantImages) variantImages.style.display = "none";
      }
    }

    // Step 2: Hide currently visible images and show instruction images
    if (instructionImages.style.display === "flex") {
      // Step 3: Show the previously visible images when clicking again
      // Pause any playing videos before switching
      const playingVideos = instructionImages.querySelectorAll("video");
      playingVideos.forEach((video) => {
        video.pause();
      });

      // Restore original descriptions
      if (descriptionsStored) {
        const englishDescElement = document.querySelector(".description-text");
        const japaneseDescElement = document.querySelector(
          ".description-text-jp"
        );

        if (englishDescElement) {
          englishDescElement.innerHTML = originalEnglishDescription;
        }
        if (japaneseDescElement) {
          japaneseDescElement.innerHTML = originalJapaneseDescription;
        }
      }

      instructionImages.style.display = "none";

      // Restore EXACTLY one base view. Always set both containers explicitly so a
      // desynced prior state can't leave product + variant (or a base + the just-
      // closed instruction) showing side by side.
      if (pvActiveBaseColumn === "variant" && variantImages) {
        variantImages.style.display = "flex"; // Show variant images if it exists
        productImages.style.display = "none";
      } else {
        // "product" or unknown → always fall back to product images so closing
        // the instruction view never leaves a blank image column.
        productImages.style.display = "flex";
        if (variantImages) variantImages.style.display = "none";
      }

      imgSize.forEach((element) => {
        if (window.innerWidth <= 700) {
          element.style.width = "80%";
        } else {
          element.style.width = "75%";
        }
        element.style.pointerEvents = "all";
      });

      instructionImages.style.display = "none"; // Hide instruction images

      imageContainer.scrollTop = 0;
      mobileImageContainer.scrollTop = 0; // Reset scroll for mobile
      if (window.innerWidth <= 700) {
        window.scrollTo(0, 0); // Reset scroll for the entire page on mobile
      }

      // Change button text back to "INSTRUCTION MANUAL" (English and Japanese)
      jpText.textContent = "取扱説明";
      enText.textContent = "INSTRUCTION MANUAL";

      // Remove dimming when closing instruction manual
      handleDescriptionDimming();
    } else {
      // Hide BOTH base containers (the remembered base is restored on close).
      // Hiding only the "currently visible" one left the other base showing next
      // to the instruction images when state had desynced — the side-by-side /
      // duplicated-images bug. Setting both unconditionally makes it impossible.
      if (productImages) productImages.style.display = "none";
      if (variantImages) variantImages.style.display = "none";

      // Show instruction images
      imgSize.forEach((element) => {
        element.style.width = "50%";
        element.style.pointerEvents = "none";
      });

      // Store original descriptions and replace with extended descriptions
      if (!descriptionsStored) {
        const englishDescElement = document.querySelector(".description-text");
        const japaneseDescElement = document.querySelector(
          ".description-text-jp"
        );

        if (englishDescElement) {
          originalEnglishDescription = englishDescElement.innerHTML;
        }
        if (japaneseDescElement) {
          originalJapaneseDescription = japaneseDescElement.innerHTML;
        }
        descriptionsStored = true;
      }

      // Replace with extended descriptions from hidden containers
      const englishDescElement = document.querySelector(".description-text");
      const japaneseDescElement = document.querySelector(
        ".description-text-jp"
      );

      // Get extended descriptions from hidden containers
      const extendedEnglishContainer = document.getElementById(
        "extended-english-desc"
      );
      const extendedJapaneseContainer = document.getElementById(
        "extended-japanese-desc"
      );

      // Get the innerHTML from the hidden containers
      // metafield_tag wraps content in a div, so we get the innerHTML directly
      const extendedEnglish = extendedEnglishContainer
        ? extendedEnglishContainer.innerHTML
        : "";
      const extendedJapanese = extendedJapaneseContainer
        ? extendedJapaneseContainer.innerHTML
        : "";

      // Only replace if we have actual extended content
      // Important: Keep the same structure - English first, then Japanese
      if (englishDescElement && extendedEnglish.trim() !== "") {
        // Keep the HTML formatting (including line breaks, paragraphs, empty lines, etc.)
        // Do NOT trim - this preserves whitespace and empty paragraphs
        englishDescElement.innerHTML = extendedEnglish;
      }
      if (japaneseDescElement && extendedJapanese.trim() !== "") {
        // Keep the HTML formatting (including line breaks, paragraphs, empty lines, etc.)
        // Do NOT trim - this preserves whitespace and empty paragraphs
        japaneseDescElement.innerHTML = extendedJapanese;
      }

      instructionImages.style.display = "flex";
      window.addEventListener("resize", handleResize);
      handleResize();

      // Apply dimming if needed on mobile
      handleDescriptionDimming();

      // Reset scroll position for desktop and mobile containers
      imageContainer.scrollTop = 0;
      mobileImageContainer.scrollTop = 0; // Reset scroll for mobile
      if (window.innerWidth <= 700) {
        window.scrollTo(0, 0); // Reset scroll for the entire page on mobile
      }

      // Change button text to "PRODUCT IMAGES" (English and Japanese)
      jpText.textContent = "商品画像";
      enText.textContent = "IMAGES";
    }
  });
}
